import moment from 'moment';
export const getDisplayString = (dateString: any, fromRequiredDoc = false) => {
  if (!dateString) {
    return '-';
  }
  const currentDate = moment().startOf('day');
  const inputDate = moment(dateString).startOf('day');

  const diffInDays = currentDate.diff(inputDate, 'days');

  if (diffInDays === 0) {
    return 'Today';
  } else if (diffInDays === 1) {
    return 'Yesterday';
  } else if (diffInDays === -1) {
    return 'Tomorrow';
  } else {
    const absoluteDiffInDays = Math.abs(diffInDays);
    const daysString = absoluteDiffInDays > 1 ? `${absoluteDiffInDays} days` : '1 day';

    if (diffInDays > 0) {
      return `${daysString} ago`;
    } else {
      if (fromRequiredDoc) {
        return `In ${daysString}`;
      } else {
        return `${daysString} to go`;
      }
    }
  }
};
